import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import "./SearchInput.css";
import remiseWEB from './assets/remiseWEB.png';

export default class SearchInput extends PureComponent {
  static propTypes = {
    textChange: PropTypes.func,
    brandName: PropTypes.string
  };

  handleChange = event => {
    this.props.textChange(event);
  };

  render() {
    return (
      <>
      

      <div className = "results-title">
        <div className="offreWEB" >
          <img width="100%"  alt="qualirepar" src={remiseWEB} />
        </div>
      Sélectionner le modèle de votre {this.props.category.LibelleCategorie} {this.props.brandName}
      </div>
      <div className="component-search-input">
          <div className="component-search-box">
          <div className="input-prefix">
          <svg className="img-search" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="7"></circle>
            <line x1="21" y1="21" x2="16.5" y2="16.5"></line>
          </svg>
          </div>
            <input id="search" type="text" onChange={this.handleChange} placeholder="Rechercher votre appareil..." />
          </div>
      </div>
      </>
    );
  }
}
